import Data from "../application/Data";
import Utils from "./Utils";
import Vue from "vue";

export default class DataUtils {

    /**
     * The `parseData` function in TypeScript parses and organizes data related to products and
     * countries based on certain conditions.
     */
    static parseData(){
        Data.data.markets = Data.marketsJson;
        Data.data.colors = Data.colorsJson;
        Data.data.finish = Data.finishJson;

        this.setMissingTranslationsForMappings();

        //PRODUCTS
        this.parseProducts("general", Data.productsJson, Data.baseProductsJson);
        if (Data.data.platform.id == "MYVERALLIA") this.parseProducts("myproducts", Data.myProductsJson, Data.myProductsBaseProductsJson);

        Data.data.products = Data.productsJson;
        Data.data.baseProducts = Data.baseProductsJson;


        //COUNTRIES
        if (Data.data.platform.id == "INTERNAL"){
            let countries: string[] = [];
            let productOwner: string[] = [];
            let productionCountries: string[] = [];

            let str: string;
            for (str in Data.data.products) {
                if (Data.data.products[str].countries) {
                    for (let i = 0; i < Data.data.products[str].countries.length; i++) {
                        if (!Data.data.products[str].countries[i]) continue;
                        let country: string = Data.data.products[str].countries[i].toLowerCase();
                        if (Data.data.config.authorizedCountries.indexOf(country) == -1) continue;

                        if (countries.indexOf(country) == -1) countries.push(country);
                    }
                }
            }

            for (str in Data.data.baseProducts) {
                if (Data.data.baseProducts[str].productOwner) {
                    for (let i = 0; i < Data.data.baseProducts[str].productOwner.length; i++) {
                        if (!Data.data.baseProducts[str].productOwner[i]) continue;
                        let country: string = Data.data.baseProducts[str].productOwner[i].toLowerCase();
                        if (Data.data.config.authorizedCountries.indexOf(country) == -1) continue;

                        if (productOwner.indexOf(country) == -1) productOwner.push(country);
                    }
                }
                if (Data.data.baseProducts[str].productionCountries) {
                    for (let i = 0; i < Data.data.baseProducts[str].productionCountries.length; i++) {
                        if (!Data.data.baseProducts[str].productionCountries[i]) continue;
                        let country: string = Data.data.baseProducts[str].productionCountries[i].toLowerCase();
                        if (Data.data.config.authorizedCountries.indexOf(country) == -1) continue;

                        if (productionCountries.indexOf(country) == -1) productionCountries.push(country);
                    }
                }
            }

            countries.sort();
            productOwner.sort();
            productionCountries.sort();

            Data.data.config.countries = countries;

            let a: number = countries.length;
            for (let i = 0; i < a; i++) {
                if (countries[i] != "us") Data.data.countries.push({ id: countries[i], selected: false });
            }

            a = productOwner.length;
            for (let i = 0; i < a; i++) {
                if (productOwner[i] != "us") Data.data.productOwner.push({ id: productOwner[i], selected: false });
            }

            a = productionCountries.length;
            for (let i = 0; i < a; i++) {
                if (productionCountries[i] != "us") Data.data.productionCountries.push({ id: productionCountries[i], selected: false });
            }
        }
    }
    /**
     * The function `parseProducts` in TypeScript parses and processes product and base product data,
     * updating various properties and ranges.
     * @param {string} mode - The `mode` parameter in the `parseProducts` function seems to indicate a
     * specific mode or context in which the products are being parsed. It is used to determine how
     * certain properties of the products should be handled or processed based on the mode specified.
     * The function appears to parse product data from `products
     * @param {any} productsJson - The `parseProducts` function you provided seems to be parsing
     * product and base product data from JSON objects. The `productsJson` parameter likely contains
     * product information, while the `baseProductsJson` parameter contains base product information.
     * @param {any} baseProductsJson - The `parseProducts` function you provided seems to be parsing
     * product and base product data from JSON objects. It sets various properties for each product and
     * base product, such as color, type, dimensions, images, owners, countries, and more.
     */
    static parseProducts(mode:string, productsJson:any, baseProductsJson:any){
        //PRODUCTS
        let str: string;
        for (str in productsJson) {
            let product: any = productsJson[str];

            if (!product.parsed) {
                product.parsed = true;

                product.colorIndex = 0;
                product.bpIndex = 0;
                product.productType = "bottle";
                product.glassDrawingLink = null;
                product.dilatationCurvesLink = null;
                product.infoDisplay = false;
                product.finish = this.setProductFinish(product);

                // if (!product.height) product.height = 10;
                // if (!product.weight) product.weight = 10;
                // if (!product.diameter) product.diameter = 10;
                // if (!product.fd) product.fd = 10;
                // if (!product.cm) product.cm = 10;
                // if (!product.overflowCapacity) product.overflowCapacity = 10;
                // if (!product.fillingHeight) product.fillingHeight = 10;
                // if (!product.finishID){
                //     // if (!product.volume) product.volume = 0.01;
                //     // product.volume *= 1000;
                // }

                if (product.height) product.height = Math.round(product.height);
                if (product.weight) product.weight = Math.round(product.weight);
                if (product.diameter) product.diameter = Math.round(product.diameter);
                if (product.fd) product.fd = Math.round(product.fd);
                if (product.overflowCapacity) product.overflowCapacity = Math.round(product.overflowCapacity) / 10;
                if (product.fillingHeight) product.fillingHeight = Math.round(product.fillingHeight);
                if (product.volume) product.volume = Math.round(product.volume * 100);
                if (product.cm) product.cm = Math.round(product.cm);

                product.owners = [];
                let a: number = product.baseProducts.length;
                for (let i = 0; i < a; i++) {
                    let bp: any = baseProductsJson[product.baseProducts[i]];
                    if (bp && bp.materialGroup.toLowerCase().indexOf("naa") == -1) {
                        product.productType = "jar";
                    }

                    if (product.owners.indexOf(bp.productOwner) == -1) product.owners.push(bp.productOwner);
                    if (product.countries.indexOf(bp.productOwner) == -1) product.countries.push(bp.productOwner);
                }

                this.extractBrandFromProduct(product);
                //if (Data.data.platform.id == "INTERNAL") this.extractBrandFromProduct(product);
            }


            if (product.height && Data.data.height.max < product.height) Data.data.height.max = Data.data.height.range[1] = product.height;
            if (product.height && Data.data.height.min > product.height) Data.data.height.min = Data.data.height.range[0] = product.height;

            if (product.weight && Data.data.weight.max < product.weight) Data.data.weight.max = Data.data.weight.range[1] = product.weight;
            if (product.weight && Data.data.weight.min > product.weight) Data.data.weight.min = Data.data.weight.range[0] = product.weight;

            if (product.diameter && Data.data.diameter.max < product.diameter) Data.data.diameter.max = Data.data.diameter.range[1] = product.diameter;
            if (product.diameter && Data.data.diameter.min > product.diameter) Data.data.diameter.min = Data.data.diameter.range[0] = product.diameter;

            if (product.fd && Data.data.finishDiameter.max < product.fd) Data.data.finishDiameter.max = Data.data.finishDiameter.range[1] = product.fd;
            if (product.fd && Data.data.finishDiameter.min > product.fd) Data.data.finishDiameter.min = Data.data.finishDiameter.range[0] = product.fd;

            if (product.cm && Data.data.carbonationMax.max < product.cm) Data.data.carbonationMax.max = Data.data.carbonationMax.range[1] = product.cm;
            if (product.cm && Data.data.carbonationMax.min > product.cm) Data.data.carbonationMax.min = Data.data.carbonationMax.range[0] = product.cm;

            if (product.volume && Data.data.volume.max < product.volume) Data.data.volume.max = Data.data.volume.range[1] = product.volume;
            if (product.volume && Data.data.volume.min > product.volume) Data.data.volume.min = Data.data.volume.range[0] = product.volume;
        }

        //BASE PRODUCTS
        for (str in baseProductsJson) {
            let baseProduct: any = baseProductsJson[str];

            if (!baseProduct.parsed){
                baseProduct.parsed = true;
                baseProduct.colors = this.setBaseProductColors(baseProduct);

                //if (baseProduct.sapColor == "01") console.log(baseProduct.colors);

                baseProduct.zoomPicture = false;
                baseProduct.pls = false;
                baseProduct.nbImages = baseProduct.images || 1;
                baseProduct.images = [Data.data.platform.productsImages + 'large/' + str + ".jpg"];



                for (let i = 1; i <baseProduct.nbImages; i++){
                    baseProduct.images.push(Data.data.platform.productsImages + 'large/' + str + "_" + i + ".jpg");
                }

                baseProduct.productOwner = [baseProduct.productOwner];
                baseProduct.productionCountries = [];
                let str2: string;
                for (str2 in baseProduct.pc){
                    baseProduct.productionCountries.push(str2);
                }

                if (Data.data.platform.id == "MYVERALLIA") this.extractFinishedProductsFromBaseProduct(mode, baseProduct, str);
            }
        }
    }
    /**
     * The function `parseFilters` iterates through various data arrays to set selected and enabled
     * properties based on certain conditions.
     */
    static parseFilters(){
        let a: number = Data.data.markets.length;
        for (let i = 0; i < a; i++) {
            Data.data.markets[i].selected = false;
            Data.data.markets[i].enabled = true;

            if(Data.data.platform.id == "MYVERALLIA"){
                Data.data.markets[i].selected = Data.data.markets[i].default;
            }

            for(let k=0; k<Data.data.config.languages.length; k++){
                let l: string = Data.data.config.languages[k];

                if (!Data.data.markets[i]["name-" + l]) Data.data.markets[i]["name-" + l] = Data.data.markets[i]["name-en_us"];
            }

            let b: number = Data.data.markets[i].sub.length;
            for (let j = 0; j < b; j++) {
                Data.data.markets[i].sub[j].selected = false;
                Data.data.markets[i].sub[j].enabled = true;

                //PAS DE DEFAULT DANS LES SOUS MARCH2S
                // if (Data.data.platform.id == "MYVERALLIA") {
                //     Data.data.markets[i].sub[j].selected = Data.data.markets[i].sub[j].default;
                // }

                for (let k = 0; k < Data.data.config.languages.length; k++) {
                    let l: string = Data.data.config.languages[k];

                    if (!Data.data.markets[i].sub[j]["name-" + l]) Data.data.markets[i].sub[j]["name-" + l] = Data.data.markets[i].sub[j]["name-en_us"];
                }
            }
        }

        a = Data.data.colors.length;
        for (let i = 0; i < a; i++) {
            Data.data.colors[i].selected = false;
            Data.data.colors[i].enabled = true;

            let b: number = Data.data.colors[i].sub.length;
            for(let j=0; j<b; j++){
                Data.data.colors[i].sub[j].selected = false;
                Data.data.colors[i].sub[j].enabled = true;
            }
        }

        a = Data.data.finish.length;
        for (let i = 0; i < a; i++) {
            Data.data.finish[i].selected = false;
            Data.data.finish[i].enabled = true;

            let b: number = Data.data.finish[i].sub.length;
            for (let j = 0; j < b; j++) {
                Data.data.finish[i].sub[j].selected = false;
                Data.data.finish[i].sub[j].enabled = true;
            }
        }

        // if (Data.data.productsLines){
        //     a = Data.data.productsLines.length;
        //     for (let i = 0; i < a; i++) {
        //         Data.data.productsLines[i].selected = false;
        //         Data.data.productsLines[i].enabled = true;
        //         Data.data.productsLines[i].sub = [];
        //     }
        // }
    }
    /**
     * The function `parsePLS` processes data from a PLS file, updating various properties and arrays
     * in the `Data` object.
     * @returns This function `parsePLS()` is not returning any value explicitly. It is a void function
     * that processes data from a PLS file and updates various data structures in the `Data` object
     * based on the information extracted from the PLS file.
     */
    static parsePLS() {
        try{
            let pls: any = Data.plsJson.data;

            let a:number = pls.length;
            for(let i=0; i<a; i++){
                if (Data.data.baseProducts[pls[i].baseProduct]){
                    Data.data.baseProducts[pls[i].baseProduct].pls = true;
                    if (!Data.data.plsProducts[pls[i].baseProduct]) Data.data.plsProducts[pls[i].baseProduct] = [];

                    Data.data.plsProducts[pls[i].baseProduct].push(pls[i]);

                    if (pls[i].images && pls[i].images.length > 0){
                        //for (let j = 0; j < pls[i].images.length; j++){
                        for (let j = 0; j < 1; j++){
                            //Data.data.baseProducts[pls[i].baseProduct].images.push(pls[i].images[j].urlL);
                            Data.data.baseProducts[pls[i].baseProduct].images.push(pls[i].images[j].urlL.replace("-xlarge", "-whr"));
                        }
                    }

                    pls[i].commercial = pls[i].salesGroupLastName + " " + pls[i].salesGroupFirstName;


                    // PLS SALES OFFICE
                    if (pls[i].salesOfficeDescription && Data.data.plsSalesOffice.data.indexOf(pls[i].salesOfficeDescription) == -1){
                        Data.data.plsSalesOffice.data.push(pls[i].salesOfficeDescription);
                    }

                    // PLS FILLING
                    if (pls[i].filling && Data.data.plsFilling.data.indexOf(pls[i].filling) == -1) {
                        Data.data.plsFilling.data.push(pls[i].filling);
                    }

                    // PLS CLIENTS
                    if (pls[i].customerName && Data.data.plsClients.data.indexOf(pls[i].customerName) == -1) {
                        Data.data.plsClients.data.push(pls[i].customerName);
                    }

                    // PLS COMMERCIAL
                    if (pls[i].commercial && Data.data.plsCommercial.data.indexOf(pls[i].commercial) == -1) {
                        Data.data.plsCommercial.data.push(pls[i].commercial);
                    }

                    // PLS DECORATORS
                    if (pls[i].decoration && Data.data.plsDecorators.data.indexOf(pls[i].decoration) == -1) {
                        Data.data.plsDecorators.data.push(pls[i].decoration);
                    }

                    // PLS COMMUNICATION
                    if (pls[i].communication && Data.data.plsCommunication.data.indexOf(pls[i].communication) == -1) {
                        Data.data.plsCommunication.data.push(pls[i].communication);
                    }

                    // PLS CFEATION DATE
                    if (pls[i].creationDate){
                        pls[i].creationDate = pls[i].creationDate.split("T")[0];

                        if (Data.data.plsCreationDate.dates.indexOf(pls[i].creationDate) == -1) {
                            Data.data.plsCreationDate.dates.push(pls[i].creationDate);
                        }

                        Data.data.plsCreationDate.dates.sort(function (a, b){
                            return a.localeCompare(b)
                        });

                        Data.data.plsCreationDate.startDate = Data.data.plsCreationDate.dates[0];
                        Data.data.plsCreationDate.endDate = Data.data.plsCreationDate.dates[Data.data.plsCreationDate.dates.length - 1];
                    }

                    // PLS LAUNCH DATE
                    if (pls[i].launchDate) {
                        pls[i].launchDate = pls[i].launchDate.split("T")[0];

                        if (Data.data.plsLaunchDate.dates.indexOf(pls[i].launchDate) == -1) {
                            Data.data.plsLaunchDate.dates.push(pls[i].launchDate);
                        }

                        Data.data.plsLaunchDate.dates.sort(function (a, b) {
                            return a.localeCompare(b)
                        });

                        Data.data.plsLaunchDate.startDate = Data.data.plsLaunchDate.dates[0];
                        Data.data.plsLaunchDate.endDate = Data.data.plsLaunchDate.dates[Data.data.plsLaunchDate.dates.length - 1];
                    }
                }
            }
        }catch(e){
            console.log("ERROR IN PLS FILE !!!");
            console.log(e);
        }
    }
    /**
     * The function `getColorWithID` searches for a color with a specific ID in a data structure and
     * returns the color data if found.
     * @param {string} id - The `id` parameter in the `getColorWithID` function is a string that
     * represents the ID of the color you want to retrieve from the `Data.data.colors` array. The
     * function iterates through the colors array and its sub-elements to find a matching ID and
     * returns the color data if found
     * @returns The `getColorWithID` function is returning an object with two properties: `color` and
     * `colorData`. The `color` property contains the color object that matches the provided ID, and
     * the `colorData` property contains an object with the ID of the parent color and an array of
     * sub-color data objects. If no matching color is found, the function returns `null`.
     */
    static getColorWithID(id:string):any{
        for(let i=0; i<Data.data.colors.length; i++){
            let color: any = Data.data.colors[i];

            for(let j=0; j<color.sub.length; j++){
                if (String(color.sub[j].id) === String(id)){
                    let colorData: any = { id: color.sub[j].id };
                    return { color: color.sub[j], colorData: { id: color.id, sub: [colorData] } };
                }
            }
        }

        return null;
    }
    /**
     * The function `getFinishWithID` retrieves finish data based on a given ID from a nested data
     * structure.
     * @param {string} id - The `id` parameter is a string that represents the identifier of the finish
     * data you are looking for. The `getFinishWithID` function searches for the finish data that
     * matches this specific `id`.
     * @returns The `getFinishWithID` function is returning an object with two properties: `finish` and
     * `finishData`. The `finish` property contains the finish object that matches the provided `id`,
     * and the `finishData` property contains an object with the `id` of the finish and an array of
     * sub-finish data. If no match is found, the function returns `null`.
     */
    static getFinishWithID(id: string): any {
        for (let i = 0; i < Data.data.finish.length; i++) {
            let finish: any = Data.data.finish[i];

            for (let j = 0; j < finish.sub.length; j++) {
                if (finish.sub[j].id == id) {
                    let finishData: any = { id: finish.sub[j].id };
                    return { finish: finish.sub[j], finishData: { id: finish.id, sub: [finishData] } };
                }
            }
        }

        return null;
    }
    /**
     * The function `setProductFinish` in TypeScript sets the finish of a product based on its
     * properties.
     * @param {any} product - The `setProductFinish` function takes a `product` object as a parameter.
     * The `product` object is expected to have properties like `finishID`, `finishFamily`, and
     * `finishSubFamily`.
     * @returns The function `setProductFinish` returns an array containing an object with `id` and
     * `sub` properties. The `id` property is either the `finishID` of the product or the
     * `finishFamily` if `finishID` is not present. The `sub` property is an array containing an object
     * with `id` property, which is either the `finishSubFamily` if
     */
    static setProductFinish(product:any){
        if (!product.finishID){
            if (product.finishFamily && !product.finishSubFamily) return [{ id: product.finishFamily, sub: [] }];
            else return [{ id: product.finishFamily, sub: [{ id: product.finishSubFamily }] }];
        } else {
            for (let i = 0; i < Data.data.finish.length; i++) {
                let finish: any = Data.data.finish[i];

                if (finish.id == product.finishID) {
                    return [{ id: finish.id, sub: [] }];
                }

                for (let j = 0; j < finish.sub.length; j++) {
                    if (finish.sub[j].id == product.finishID) {
                        return [{ id: finish.id, sub: [{ id: finish.sub[j].id }] }];
                    }
                }
            }
        }

        return null;
    }
    /**
     * The function `setBaseProductColors` iterates through color data to match a base product's color
     * and returns the corresponding color object.
     * @param {any} baseProduct - The `setBaseProductColors` function takes a `baseProduct` object as a
     * parameter. This object is used to determine the colors for a product based on the `sapColor`
     * property within the `baseProduct` object. The function iterates through the `Data.data.colors`
     * array to find
     * @returns If a match is found between the `baseProduct.sapColor` and a color's sub id in the
     * `Data.data.colors` array, a new array containing the matched color id and sub id will be
     * returned. If no match is found, `null` will be returned.
     */
    static setBaseProductColors(baseProduct: any) {
        for (let i = 0; i < Data.data.colors.length; i++) {
            let color: any = Data.data.colors[i];

            // if (color.id == baseProduct.sapColor) {
            //     return [{ id: color.id, sub: [] }];
            // }

            for (let j = 0; j < color.sub.length; j++) {
                //

                if (String(color.sub[j].id) === String(baseProduct.sapColor)) {
                    return [{ id: color.id, sub: [{ id: color.sub[j].id }] }];
                }
            }
        }

        return null;
    }
    /**
     * The function `extractFinishedProductsFromBaseProduct` processes and extracts finished products
     * from a base product object, updating and organizing the data accordingly.
     * @param {string} mode - The `mode` parameter in the `extractFinishedProductsFromBaseProduct`
     * function is used to determine the mode of operation. It is a string that can have different
     * values such as "myproducts" or any other mode that the function supports. The behavior of the
     * function may vary based on the value
     * @param {any} baseProduct - The `baseProduct` parameter in the
     * `extractFinishedProductsFromBaseProduct` function seems to be an object containing information
     * about finished products related to a specific base product. The function extracts and processes
     * these finished products based on certain conditions and then stores them in the
     * `Data.data.finishedProducts` object under
     * @param {string} id - The `id` parameter in the `extractFinishedProductsFromBaseProduct` function
     * is used to identify a specific base product for which finished products need to be extracted and
     * processed. It is used to store and retrieve finished products related to a particular base
     * product in the `Data.data.finishedProducts` object.
     * @returns This function does not have a return statement, so it does not explicitly return
     * anything. It mainly performs operations on the `finishedProducts` array and updates the
     * `Data.data.finishedProducts[id]` array based on certain conditions and input parameters.
     */
    static extractFinishedProductsFromBaseProduct(mode:string, baseProduct:any, id:string){
        if (!Data.data.finishedProducts[id]) Data.data.finishedProducts[id] = [];

        if (!baseProduct.fip || baseProduct.fip.length == 0) return;


        let finishedProducts: any = baseProduct.fip;
        baseProduct.selected_line = 0;

        let a: number = finishedProducts.length;
        for (let i = 0; i < a; i++) {

            finishedProducts[i].id = finishedProducts[i].cf.slice(2);
            finishedProducts[i].channel = finishedProducts[i].cf.substring(0, 2);
            delete finishedProducts[i].cf;


            if (finishedProducts[i].mg) finishedProducts[i].materialGroup = finishedProducts[i].mg.toLowerCase();
            delete finishedProducts[i].mg;

            finishedProducts[i].quantity = 1;
            finishedProducts[i].display = true;

            if (finishedProducts[i].materialGroup) {
                if (finishedProducts[i].materialGroup.toLowerCase() == "naac" || finishedProducts[i].materialGroup.toLowerCase() == "naaa" || finishedProducts[i].materialGroup.toLowerCase() == "naba" || finishedProducts[i].materialGroup.toLowerCase() == "nabc") finishedProducts[i].display = true;
                else finishedProducts[i].display = false;
            }

            if (!finishedProducts[i].materialGroup) finishedProducts[i].display = false;
            if (finishedProducts[i].stsp) finishedProducts[i].standard = finishedProducts[i].stsp.toLowerCase();
            delete finishedProducts[i].stsp;


            finishedProducts[i].palletHeight = finishedProducts[i].hp;
            //delete finishedProducts[i].hp;

            finishedProducts[i].nbRows = finishedProducts[i].nip;
            //delete finishedProducts[i].nip;

            finishedProducts[i].nbLayer = finishedProducts[i].nl;
            //delete finishedProducts[i].nl;

            finishedProducts[i].nbUnitLayer = finishedProducts[i].ni;
            //delete finishedProducts[i].ni;

            finishedProducts[i].grossWeight = finishedProducts[i].wg;
            //delete finishedProducts[i].wg;

            finishedProducts[i].palletCode = finishedProducts[i].pm;
            //delete finishedProducts[i].pm;

            finishedProducts[i].palletType = finishedProducts[i].pa;
            //delete finishedProducts[i].pa;

            finishedProducts[i].layerDisposition = finishedProducts[i].pc;
            //delete finishedProducts[i].pc;



            let status: any = ["st", "sr"];
            //if (finishedProducts[i].standard && status.indexOf(finishedProducts[i].standard.toLowerCase()) == -1) finishedProducts[i].display = false;
            //if (!finishedProducts[i].standard) finishedProducts[i].display = false;

            if (mode == "myproducts" && finishedProducts[i].display) {
                if (finishedProducts[i].fp == true) {
                    baseProduct.favorite = true;
                }

                finishedProducts[i].favorite = finishedProducts[i].fp;
            }


            if (finishedProducts[i].display){
                let FPFound:any = false;
                for (let j = 0; j < Data.data.finishedProducts[id].length; j++){
                    if (Data.data.finishedProducts[id][j].id == finishedProducts[i].id){
                        FPFound = Data.data.finishedProducts[id][j];

                        if (mode == "myproducts"){
                            Data.data.finishedProducts[id][j].favorite = finishedProducts[i].favorite;
                            //if (finishedProducts[i].id == "9073952") console.log("found", Data.data.finishedProducts[id][j]);
                        }

                        break;
                    }
                }

                if (!FPFound) Data.data.finishedProducts[id].push(finishedProducts[i]);
            }
        }
    }
    /**
     * The function `extractBrandFromProduct` adds a new brand to the Data object based on the
     * product's brand information.
     * @param {any} product - The `extractBrandFromProduct` function takes a `product` object as a
     * parameter. This object is expected to have a property `br` which represents the brand ID of the
     * product.
     * @returns In the provided code snippet, the `extractBrandFromProduct` function is iterating over
     * a list of brands in `Data.data.brands` and checking if the `id` of the current brand matches the
     * `br` property of the `product` object. If a match is found, the function returns without
     * performing any further actions.
     */
    static extractBrandFromProduct(product:any){
        product.brands = [{ id: product.br, sub: [] }];

        for(let i=0; i<Data.data.brands.length; i++){
            if (Data.data.brands[i].id == product.br) return;
        }

        let brand: any = { id: product.br, sub: [], enabled:true, selected:false };
        for (let i = 0; i < Data.data.config.languages.length; i++) {
            let l: string = Data.data.config.languages[i];

            brand["name-" + l] = product.br;
        }

        Data.data.brands.push(brand);
    }




    /**
     * This function retrieves the channel code based on the country provided.
     * @param {string} country - The `getChannelCodeFromCountry` function takes a `country` parameter
     * as input. This function iterates over the `companyCode` object in the `Data.data.config` and
     * checks if the `country` property of each entry matches the input `country`. If a match is found,
     * it
     * @returns The function `getChannelCodeFromCountry` returns the channel code associated with the
     * input country.
     */
    static getChannelCodeFromCountry(country: string) {
        let str: string;
        for (str in Data.data.config.companyCode) {
            if (Data.data.config.companyCode[str].country == country) return str;
        }
    }
    /**
     * This function retrieves the company code based on the country provided.
     * @param {string} country - The `country` parameter is a string representing the name of a country
     * for which you want to retrieve the company code.
     * @returns The company code corresponding to the provided country is being returned.
     */
    static getCompanyCodeFromCountry(country:string){
        let str:string;
        for (str in Data.data.config.companyCode){
            if (Data.data.config.companyCode[str].country == country) return Data.data.config.companyCode[str].code;
        }
    }
    /**
     * The function `getProductName` in TypeScript retrieves the product name based on various
     * conditions such as platform, language, labels, and country.
     * @param {any} product - Based on the provided code snippet, the `getProductName` function takes a
     * `product` object as a parameter. The function attempts to determine the appropriate product name
     * based on various conditions such as platform, language, labels, and country information stored
     * in the `Data` object.
     * @returns The function `getProductName` returns the label of a product based on various
     * conditions and fallbacks. It first checks if the platform ID is "INTERNAL" and returns the
     * product name if available, otherwise it returns the product ID.
     */
    static getProductName(product: any) {
        if(Data.data.platform.id == "INTERNAL"){
            if (product.name) return product.name;

            return product.id;
        }


        let language: string = Data.data.language;
        let label: string = product.labels[language];

        if(!label){
            let str: string;
            for (str in product.labels) {
                label = product.labels[str];
                break;
            }
        }

        if (!label) label = product.name;


        return label;


        let country:string = Utils.getCountryFromLanguage(language);
        country = null;
        if (!country) country = Data.data.baseProducts[product.baseProducts[product.bpIndex]].productOwner[0];
        //let label: string = product.labels[country + "_" + language];

        country = Data.data.baseProducts[product.baseProducts[product.bpIndex]].productOwner[0];

        if (!label) label = product.labels[country + "_" + language];


        if (!label){
            let languages: string = Data.data.config.countriesLanguages[country];
            language = "en_us";
            if (languages) language = languages[0];

            label = product.labels[country + "_" + language];
        }


        if (!label && Data.data.language != "en_us") label = product.labels[country + "_en_us"];
        //label = product.labels[owner + "_" + language];

        if (!label) {
            let str: string;
            for (str in product.labels) {
                label = product.labels[str];
                break;
            }
        }

        if (!label) label = product.name;

        return label;
    }
    /**
     * The function `getVGColorFromProduct` retrieves a color based on a product and base product code.
     * @param {any} product - The `getVGColorFromProduct` function takes two parameters:
     * @param {string} bpCode - The `bpCode` parameter is a string that represents the code of a base
     * product.
     * @returns the VG color that matches the base product's SAP color and is available in one of the
     * countries associated with the base product. If a matching color is found, it will be logged to
     * the console and returned. If no matching color is found, the function will return null.
     */
    static getVGColorFromProduct(product:any, bpCode:string){
        let baseProduct: any = Data.data.baseProducts[bpCode];

        for(let str in Data.data.vg.colors){
            let color: any = Data.data.vg.colors[str];

            if (color.sapColor == baseProduct.sapColor){
                for (let i = 0; i < baseProduct.countries.length; i++){
                    let bpCountry: string = baseProduct.countries[i];

                    if (color.countries.indexOf(bpCountry) != -1){
                        console.log("found color", str);
                        return str;
                    }
                }
            }
        }

        return null;
    }
    static mapOldLanguagesForVG() {
        console.log("mapping old languages for colors and contents");

        let str: string;
        for (str in Data.data.vg.colors) {
            Data.data.vg.colors[str].translations;

            let str2: string
            for (str2 in Data.data.config.oldLanguagesMappingVG) {
                if (Data.data.vg.colors[str].translations[str2]) {
                    let newL: string = Data.data.config.oldLanguagesMappingVG[str2];

                    Data.data.vg.colors[str].translations[newL] = Data.data.vg.colors[str].translations[str2];
                    delete Data.data.vg.colors[str].translations[str2];
                }
            }
        }


        let str3: string;
        for (str3 in Data.data.vg.contents) {
            for (str in Data.data.vg.contents[str3]) {
                Data.data.vg.contents[str3][str].translations;

                let str2: string
                for (str2 in Data.data.config.oldLanguagesMappingVG) {
                    if (Data.data.vg.contents[str3][str].translations[str2]) {
                        let newL: string = Data.data.config.oldLanguagesMappingVG[str2];

                        Data.data.vg.contents[str3][str].translations[newL] = Data.data.vg.contents[str3][str].translations[str2];
                        delete Data.data.vg.contents[str3][str].translations[str2];
                    }
                }
            }
        }
    }
    /**
     * The function `setMissingTranslationsForMappings` is used to handle missing translations for
     * mappings in TypeScript.
     */
    private static setMissingTranslationsForMappings(){
        //to do if necessary to have all keys for every languages
    }
}